
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { logout, changeState, mudarProcesso } from '../actions/AppActions';
import { connect } from 'react-redux';

import moment from 'moment-timezone';
import { decrypt, URL } from '../variables';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import Redacao from './Redacao';
import { Tab, Tabs } from 'react-bootstrap';

const DecideBorder = (resposta, correta, atual) => {
    console.log(resposta,correta,atual)
    if (atual == resposta && resposta == correta) {
        return '1px solid green';
    }
    else if (atual == resposta) {
        return '1px solid red';
    }
    else if (atual == correta) {
        return '1px solid green';
    }
    else {
        return '';
    }
}

class Finalizada extends Component {

    constructor(props) {
        super(props);
        this.state = {
            menu: false,
            redirect: false,
            path: '/',
            tab: 0,

        };
        this.unmont_ = false;

    }


    componentDidMount() {
        this.props.changeStateParent({ show_face_mesh: false });
        // this.props.object_worker.terminate();
        if (this.props.processo.simulado == false) {
            this.logs_timeout = setTimeout(() => {
                this.salvar_log();
            }, this.props.processo.save_timer_pre_exam);
        }
        else {
            this.logs_timeout = setTimeout(() => {
                localStorage.removeItem('token');
                this.props.logout();
            }, 30000);
        }

      
    }

    componentWillUnmount() {
        this.unmont_ = true;

        clearTimeout(this.logs_timeout);
    }

    salvar_log() {
        fetch(`${URL}api/salvar_log?screen=finish&processo_id=${this.props.processo.id}&processo_name=${this.props.processo.name}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',

                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                resp = decrypt(resp);

                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                }
                else {
                    if (resp.status == false) {
                        this.props.get_processo();
                    }
                    else {
                        if (resp.processo != null && resp.processo.updated_at != this.props.processo.updated_at) {
                            this.props.mudarProcesso(resp.processo);
                        }
                        if (this.unmont_ == false) {

                            this.logs_timeout = setTimeout(() => {
                                this.salvar_log();
                            }, this.props.processo.save_timer_pre_exam);
                        }
                    }
                }
            } catch (err) {
                console.log(err);

                if (this.unmont_ == false) {

                    this.logs_timeout = setTimeout(() => {
                        this.salvar_log();
                    }, this.props.processo.save_timer_pre_exam);
                }
            }

        })
            .catch((err) => {
                console.log(err);
                if (this.unmont_ == false) {

                    this.logs_timeout = setTimeout(() => {
                        this.salvar_log();
                    }, this.props.processo.save_timer_pre_exam);
                }
            });
    }

    logout() {
        localStorage.removeItem('token');
        // this.setState({redirect:true,path:'/'});
        this.props.logout();
    }


  
    render() {
        let index = 0;

        return (
            <div >

                <hr />
                <div className="text-success"
                    style={{ padding: '5px 5px 5px 5px', fontWeight: 'bold', fontSize: '1.4rem', textAlign: 'center' }}>
                    Avaliação finalizada com sucesso
                </div>
                {/* <hr/> */}

                <br />
                <br />
               



                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '1rem' }}>
                    <button className="btn btn-success btn-lg" onClick={this.logout.bind(this)} style={{ width: '100%' }}><i
                        className="mdi mdi-power" style={{ color: 'white' }}></i> Clique aqui para Sair</button>

                </div>

            </div>

        );
    }
}
const mapsStateToProps = (state) => (
    {
        tempo_atual: state.AppReducer.tempo_atual,
        processo: state.AppReducer.processo,
        token: state.AppReducer.token,
        user: state.AppReducer.user,

        // object_worker: state.AppReducer.object_worker,
        provas: state.AppReducer.provas,
        redacoes: state.AppReducer.redacoes,

        faculdade: state.AppReducer.faculdade,
        processo_resultado: state.AppReducer.processo_resultado,



    }
);

export default withRouter(connect(mapsStateToProps, { logout, changeState, mudarProcesso })(Finalizada));


